import { create } from 'zustand';
import { ConversationDraftState } from './interface';

export const conversationStateFactory = () =>
  create<ConversationDraftState>((set, get) => ({
    conversationContent: {},
    setConversationContent: (conversationId, content) => {
      const { conversationContent } = get();
      set({
        conversationContent: {
          ...conversationContent,
          [conversationId]: content,
        },
      });
    },
  }));
